import type { ReactNode } from 'react';
import React, { useState, useMemo } from 'react';
import type { departureCitiesContextType } from './DepartureCitiesContext';
import DepartureCitiesContext from './DepartureCitiesContext';
type Props = {
  children: ReactNode;
};
export default function DepartureCitiesProvider({ children }: Props) {
  const [departureCities, setDepartureCities] = useState<
    departureCitiesContextType['departureCities']
  >([]);

  const value = useMemo(() => ({ departureCities, setDepartureCities }), [departureCities]);

  return (
    <DepartureCitiesContext.Provider value={value}>{children}</DepartureCitiesContext.Provider>
  );
}
